import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

function PersonOfConcernModal({
  createPersonOfConcern,
  getPersonOfConcernList,
  history,
  getSinglePersonOfConcern,
  type,
  updatePersonOfConcern,
  updateList,
  personOfConcernId,
}) {
  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    suffix: '',
    is_approver: 0,
    is_recommender: 0,
    is_assessor: 0,
  });
  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    street_to: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onCheck = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createPersonOfConcern(formData, ({ data }) => {
        setModal({ isOpen: false });
        getPersonOfConcernList({ isPaginate: 1 });
        history.push(
          `/rpt/land/land-settings/person-of-concern/${_.get(data, 'id')}`
        );
        getSinglePersonOfConcern(data.id);
      });
    }

    if (type === 'EDIT') {
      updatePersonOfConcern(personOfConcernId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getPersonOfConcernList({ isPaginate: 1 });
        history.push(
          `/rpt/land/land-settings/person-of-concern/${_.get(data, 'id')}`
        );
        getSinglePersonOfConcern(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              First Name {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Middle Name
            </label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Last Name {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Suffix
            </label>
            <Select
              name="suffix"
              placeholder="Select Suffix Name"
              onChange={handleOnChangeSelect('suffix')}
              options={c.EXTENSION_NAMES}
              value={
                c.EXTENSION_NAMES.find(
                  item =>
                    _.get(formData, 'suffix') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Approver &nbsp;
            </label>
            <input
              name="is_approver"
              type="checkbox"
              checked={_.get(formData, 'is_approver') || 0}
              onChange={onCheck}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Recommender &nbsp;
            </label>
            <input
              name="is_recommender"
              type="checkbox"
              checked={_.get(formData, 'is_recommender') || 0}
              onChange={onCheck}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Assessor &nbsp;
            </label>
            <input
              name="is_assessor"
              type="checkbox"
              checked={_.get(formData, 'is_assessor') || 0}
              onChange={onCheck}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PersonOfConcernModal.defaultProps = {
  type: '',
  updateList: {},
  personOfConcernId: '',
}

PersonOfConcernModal.propTypes = {
  type: PropTypes.string,
  personOfConcernId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getPersonOfConcernList: PropTypes.instanceOf(Function).isRequired,
  createPersonOfConcern: PropTypes.instanceOf(Function).isRequired,
  updatePersonOfConcern: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSinglePersonOfConcern: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PersonOfConcernModal);
